import { Link } from 'react-router-dom';
import { features, faqItems } from '@/mocks/site';
import { categories, articles } from '@/mocks/articles';

export function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20financial%20building%20architecture%20with%20warm%20golden%20sunset%20light%2C%20clean%20geometric%20lines%2C%20professional%20corporate%20atmosphere%2C%20abstract%20architectural%20photography%2C%20warm%20amber%20and%20charcoal%20tones%2C%20luxurious%20yet%20understated%20aesthetic&width=1600&height=800&seq=hero-bg-2024&orientation=landscape"
          alt="众赢国际 - 专业金融服务平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 md:px-6 py-20">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
          众赢国际网页版登录入口
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-2xl mx-auto">
          找不到众赢国际网页版登录入口？我们提供众赢国际最新官方登录地址、网页版入口访问指南及常见登录问题解决方法，帮助您快速找到正确登录页面，安全顺畅进入众赢国际平台账户。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即登录
          </a>
          <Link
            to="/category/login-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium rounded-lg border border-white/30 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            查看登录指引
          </Link>
        </div>
      </div>
    </section>
  );
}

export function LoginGuideSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            登录入口指引
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            快速找到众赢国际网页版登录入口
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            按照以下步骤，安全快速地进入众赢国际平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { step: '01', title: '访问官网', desc: '打开众赢国际官方网站首页，认准官方域名' },
            { step: '02', title: '点击登录', desc: '点击页面右上角的"登录"按钮进入登录页' },
            { step: '03', title: '输入信息', desc: '输入注册手机号或邮箱及登录密码' },
            { step: '04', title: '安全验证', desc: '完成图形验证码或短信验证码验证后登录' },
          ].map((item) => (
            <div key={item.step} className="relative p-6 rounded-xl bg-background-100 border border-background-200/70">
              <span className="text-4xl font-heading font-bold text-primary-200">{item.step}</span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mt-3 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
            平台特色
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择众赢国际？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            专业可靠的金融服务平台，为您的投资保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors group cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function StatsSection() {
  return (
    <section className="w-full py-14 bg-primary-500">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {[
            { value: '500,000+', label: '注册用户' },
            { value: '8年', label: '安全运营' },
            { value: '200+', label: '交易品种' },
            { value: '98.6%', label: '客服满意度' },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">{stat.value}</div>
              <div className="text-sm text-primary-100">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CategoryNavSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3">
            内容导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索更多内容
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            按分类浏览，快速找到您需要的资讯
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all group cursor-pointer text-center"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mx-auto mb-3 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-snug">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ArticlePreviewSection() {
  const latestArticles = articles.slice(0, 4);

  const articleImages: Record<string, string> = {
    'article-login-guide': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20login%20page%20on%20a%20laptop%20screen%20with%20warm%20golden%20accents%2C%20clean%20professional%20financial%20platform%20interface%2C%20soft%20natural%20lighting%2C%20elegant%20workspace%20setting%2C%20warm%20beige%20background%2C%20editorial%20technology%20photography&width=640&height=400&seq=article-login-guide&orientation=landscape',
    'article-login-problems': 'https://readdy.ai/api/search-image?query=Customer%20support%20and%20help%20desk%20scene%20with%20warm%20ambient%20lighting%2C%20professional%20office%20environment%2C%20clean%20minimalist%20design%2C%20helpful%20atmosphere%2C%20warm%20beige%20tones&width=640&height=400&seq=article-login-problems&orientation=landscape',
    'article-platform-features': 'https://readdy.ai/api/search-image?query=Modern%20financial%20trading%20platform%20dashboard%20on%20large%20monitor%20screen%2C%20clean%20minimalist%20interface%20showing%20market%20charts%2C%20professional%20trading%20environment%2C%20warm%20golden%20and%20charcoal%20color%20scheme&width=640&height=400&seq=article-platform-features&orientation=landscape',
    'article-market-trends': 'https://readdy.ai/api/search-image?query=Professional%20financial%20market%20analysis%20scene%20with%20multiple%20screens%20showing%20stock%20charts%20and%20data%2C%20modern%20minimalist%20office%2C%20warm%20ambient%20lighting%2C%20clean%20professional%20aesthetic&width=640&height=400&seq=article-market-trends&orientation=landscape',
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
              最新文章
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门资讯与指南
            </h2>
          </div>
          <Link
            to="/category/login-guide"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.slug] || 'https://readdy.ai/api/search-image?query=Modern%20financial%20platform%20content%20image&width=640&height=400&seq=article-default&orientation=landscape'}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.summary}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/login-guide"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            众赢国际登录常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于登录入口、账户安全、平台使用的常见疑问
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqItems.slice(0, 6).map((faq, idx) => (
            <details key={idx} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
              <summary className="px-6 py-4 flex items-center justify-between cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 group-open:text-primary-600 transition-colors flex-shrink-0">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20geometric%20shapes%2C%20golden%20amber%20and%20charcoal%20tones%2C%20modern%20luxurious%20financial%20theme%2C%20clean%20minimalist%20style&width=1600&height=500&seq=cta-bg-2024&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-background-950/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[600px] mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          准备好开始您的投资之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/75 mb-8">
          立即登录众赢国际平台，体验安全、便捷、专业的金融服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即登录
          </a>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium rounded-lg border border-white/25 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}